const initialState = {
    data: {
        photoId: ""
    },
    ajaxCallsInProgress: 0,
    promos: {
        list: [],
        hydrated: false,
        urlCode: null,
        enteredCode: null,
    },
};

export default initialState;
